import { Refraction } from '@ca/common'
import { RemoteConfig } from '@ca/common/types'
import useFlowName from '@order/hooks/useFlowName'
import useStepsState from '@order/hooks/useStepsState'
import useOrderValues from '@order/hooks/values/useOrderValues'
import { VariableValues } from '@order/utils/OrderVariables'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'

export type StepCtx = {
  flowName: string
  values: VariableValues
  refraction?: Refraction | null
  config: RemoteConfig | null
  state: ReturnType<typeof useStepsState>
}

const useStepCtx = () => {
  const state = useStepsState()
  const { values, refraction } = useOrderValues(state)
  const config = useRemoteConfig()
  const flowName = useFlowName()

  return {
    state,
    config,
    values,
    refraction,
    flowName,
  } satisfies StepCtx
}

export default useStepCtx
